import { useMemo } from 'react';
import { useLocation } from 'react-router';

// Custom hook that builds on useLocation to parse the query string.
export function useQueryParameters() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
